const FastClick = require('fastclick');

require('babel-polyfill');
require('date-input-polyfill');
require('angular-cookies');
require('angular-ui-router');
require('angular-messages');
require('angular-google-analytics');
require('angular-translate');
require('lodash');

require('./third_party/angular-scroll/angular-scroll.js');
require('./third_party/angular-moment/angular-moment');
require('./third_party/ng-ui-select/select');
require('./third_party/angular-pickadate/angular-pickadate.js');
require('./third_party/angular-addtocalendar/addtocalendar.js');
require('./third_party/ng-idle/angular-idle.js');
require('./third_party/angular-sanitize/angular-sanitize.js');
require('./third_party/legacy/angular-fancy-modal-0.1.4/angular-fancy-modal');
require('./directives/lbTooltip');

require(`./globalStyles/app.${process.env.APP_INITIAL}.scss`);

const app = angular.module('app', [
  'ngCookies',
  'duScroll',
  'ngMessages',
  'ui.router',
  'angular-google-analytics',
  'angularMoment',
  'ui.select',
  'vesparny.fancyModal',
  require('./components/lbResolveLoader/lbResolveLoader').name,
  require('./components/lbDialog').name,
  require('./components/lbLoadingPlaceholder').name,
  require('./components/lbTimeSelect').name,
  require('./components/lbCountrySelect').name,
  require('./components/lbDateInput').name,
  require('./components/lbDatePicker/lbDatePicker').name,
  require('./components/lbPoiSelect').name,
  require('./components/lbFiveStarRating').name,
  require('./components/lbModal').name,
  require('./components/lbErrorModal/lbErrorModal').name,
  require('./components/lbTimeoutModal/lbTimeoutModal').name,
  require('./components/lbFareRulesModal/lbFareRulesModal').name,
  require('./components/lbHotelPriceCheckModal/lbHotelPriceCheckModal').name,
  require('./components/lbTripOptionsModal').name,
  require('./components/lbCarHandlingModal').name,
  require('./components/lbCurrencyMessage/lbCurrencyMessage').name,
  require('./components/lbCO2Message/lbCO2Message').name,
  require('./components/lbUutcMessage/lbUutcMessage').name,
  require('./components/lbToggle').name,
  require('./components/lbAgentChatWidget').name,
  require('./components/lbCardIcon/lbCardIcon').name,
  require('./components/lbHeader').name,
  require('./components/lbBeamer').name,
  require(`./appSpecificImports/index.${process.env.APP_INITIAL}`).name,
  'pascalprecht.translate',
  'ngSanitize',
  'app.lbTooltip',
  'ngIdle',
  'ngPatternRestrict',
  require('oclazyload'),
  require('./routes/routes.booking'),
]);

// global polyfills
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// SVG Icons
import directives from './directives/compassIcons';
Object.keys(directives).forEach((name) => {
  app.directive(name, directives[name]);
});

app.directive('lbSequentialTime', require('./directives/lbSequentialTime'));
app.directive('lbFutureTime', require('./directives/lbFutureTime'));
app.directive('focusOn', require('./directives/focusOn'));
app.directive('inputMatch', require('./directives/inputMatch'));
app.directive('inputUppercase', require('./directives/inputUppercase'));
app.directive('clickOutside', require('./directives/lbClickOutside'));
app.directive('iframeOnload', require('./directives/lbIFrameOnLoad'));

app.config([
  'uiSelectConfig',
  function (uiSelectConfig) {
    uiSelectConfig.theme = 'selectize';
  },
]);

app.config([
  '$translateProvider',
  function ($translateProvider) {
    const Lang = window.localStorage.getItem('i18nCode') || 'en-AU';
    $translateProvider
      .useSanitizeValueStrategy('sanitize')
      .translations('en-AU', require('!json!./locals/en-AU.json'))
      .translations('en-US', require('!json!./locals/en-US.json'))
      .translations('en-GB', require('!json!./locals/en-GB.json'))
      .fallbackLanguage(['en-AU', 'en-US', 'en-GB'])
      .preferredLanguage(Lang);
  },
]);

app.config([
  '$compileProvider',
  function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
  },
]);

app.config([
  'IdleProvider',
  function (IdleProvider) {
    IdleProvider.autoResume('notIdle');
    IdleProvider.idle(60 * 20);
    IdleProvider.timeout(30);
  },
]);

app.constant('APP_CONFIG', require('./config/appConfig'));
app.constant('AUTH_EVENTS', require('./constants/authConstants'));
app.constant('ENUMS', require('./constants/enums'));

app.filter('sectorGroupsFilter', require('./filters/sectorGroupsFilter'));
app.filter('creditCardNumberFilter', require('./filters/creditCardNumberFilter'));
app.filter('startCaseFilter', require('./filters/stringFilters').startCaseFilter);
app.filter('stringLengthFilter', require('./filters/stringFilters').stringLengthFilter);
app.filter('paddingFilter', require('./filters/paddingFilter'));
app.filter('noValueFilter', require('./filters/noValueFilter'));
app.filter('cssClassNameFilter', require('./filters/cssClassNameFilter'));
app.filter('genericSortingFilter', require('./filters/genericSortingFilter'));
app.filter('locationIconFilter', require('./filters/locationIconFilter'));
app.filter('distanceFilter', require('./filters/distanceFilter'));
app.filter('secondsToTimeFilter', require('./filters/secondsToTimeFilter'));
app.filter('cssClassNameFilter', require('./filters/cssClassNameFilter'));
app.filter('toAddressFilter', require('./filters/toAddressFilter'));
app.filter('keyToLabelFilter', require('./filters/keyToLabelFilter'));
app.filter('ancillaryServicesAmountsFilter', require('./filters/ancillaryServicesAmountsFilter'));
app.filter('hotelProviderBrandFilter', require('./filters/hotelProviderBrandFilter'));
app.filter('deepCopyFilter', require('./filters/deepCopyFilter'));
app.filter('checkinInfoFilter', require('./filters/checkinInfoFilter'));

app.config(require(`./routes/routes.base`));
app.config(require(`./routes/routes.${process.env.APP_INITIAL}`));
app.config(require('./config/httpProviderConfig')(app));
app.config(require('./config/gaConfig')(app));

app.factory('requestInterceptor', require('./factories/requestInterceptor'));
app.factory('$exceptionHandler', require('./factories/exceptionHandler'));

app.service('apiService', require('./services/apiService'));
app.service('appInsightsService', require('./services/appInsightsService'));
app.service('bookingsService', require('./services/bookingsService'));
app.service('activeBookingService', require('./services/activeBookingService'));
app.service('authService', require('./services/authService'));
app.service('itinerariesService', require('./services/itinerariesService'));
app.service('settingsService', require('./services/settingsService'));
app.service('travelService', require('./services/travelService'));
app.service('travelFiltersService', require('./services/travelFiltersService'));
app.service('flightFilterService', require('./services/flightFilterService'));
app.service('flailService', require('./services/flailService'));
app.service('cartService', require('./services/cartService'));
app.service('carSearchService', require('./services/carSearchService'));
app.service('sectorService', require('./services/sectorService'));
app.service('sectorChangeService', require('./services/sectorChangeService'));
app.service('searchFormService', require('./services/searchFormService'));
app.service('iataSearchService', require('./services/iataSearchService'));
app.service('departmentService', require('./services/departmentService'));
app.service('locationsSearchService', require('./services/locationsSearchService'));
app.service('depotSearchService', require('./services/depotSearchService'));
app.service('citySearchService', require('./services/citySearchService'));
app.service('locationService', require('./services/locationService'));
app.service('companyReferenceListService', require('./services/companyReferenceListService'));
app.service('dateTimeService', require('./services/dateTimeService'));
app.service('toggleService', require('./services/toggleService'));
app.service('stateResolveService', require('./services/stateResolveService'));
app.service('seatMapService', require('./services/seatMapService'));
app.service('seatNumberService', require('./services/seatNumberService'));
app.service('cdnService', require('./services/cdnService'));
app.service('lostSavingsService', require('./services/lostSavingsService'));
app.service('timesService', require('./services/timesService'));
app.service('userProfileService', require('./services/userProfileService'));
app.service('userDebtorService', require('./services/userDebtorService'));
app.service('guestTravellerService', require('./services/guestTravellerService'));
app.service('paymentMethodsService', require('./services/paymentMethodsService'));
app.service('unusedTicketsService', require('./services/unusedTicketsService'));
app.service('unusedCreditsService', require('./services/unusedCreditsService'));
app.service('beamerService', require('./services/beamerService'));

app.run([
  'Analytics',
  (Analytics) => {
    // This gets analytics started, must have reference to Analytics
  },
]);

app.run([
  '$rootScope',
  '$location',
  ($rootScope, $location) => {
    $rootScope.enableDebug = $location.search().enabledebug;
  },
]);

app.run([
  '$rootScope',
  ($rootScope) => {
    $rootScope.$on('openDatePicker', (event, settings) => {
      $rootScope.datePickerSettings = settings;
      $rootScope.showDatePicker = true;
    });

    $rootScope.$on('closeDatePicker', () => {
      $rootScope.datePickerSettings = undefined;
      $rootScope.showDatePicker = false;
    });
  },
]);

app.run([
  '$rootScope',
  '$ocLazyLoad',
  ($rootScope, $ocLazyLoad) => {
    $rootScope.$on('$stateChangeSuccess', function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    FastClick.attach(document.body);

    app.register = $ocLazyLoad.inject.bind($ocLazyLoad);
  },
]);

app.run([
  '$rootScope',
  '$timeout',
  'lbModalService',
  'authService',
  'AUTH_EVENTS',
  function ($rootScope, $timeout, lbModalService, authService, AUTH_EVENTS) {
    $rootScope.$on('IdleStart', function () {
      $timeout(function () {
        lbModalService.open('<lb-timeout-modal></lb-timeout-modal>');
      });
    });

    $rootScope.$on('IdleTimeout', function () {
      authService.logout().then(function () {
        lbModalService.resolve();
        $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
        $rootScope.$broadcast('closeDatePicker');
      });
    });
  },
]);

app.run([
  '$rootScope',
  '$state',
  '$fancyModal',
  'authService',
  ($rootScope, $state, $fancyModal, authService) =>
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      $fancyModal.close();
      if (!authService.isAuthenticated()) {
        app.previousSate = {
          toState,
          toParams,
        };

        if (!(toParams.isPublic || (toState.data && toState.data.isPublic))) {
          event.preventDefault();
          $state.go('landing.login');
          return;
        }
      }

      if (toState.redirectTo) {
        event.preventDefault();
        $state.go(toState.redirectTo, toParams);
        return;
      }
      $rootScope.showLoader = !!toState.resolve;
    }),
]);

app.run([
  '$rootScope',
  '$state',
  '$window',
  'Analytics',
  'Idle',
  'authService',
  'appInsightsService',
  'APP_CONFIG',
  ($rootScope, $state, $window, Analytics, Idle, authService, appInsightsService, APP_CONFIG) =>
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      $rootScope.showLoader = false;
      const pagePath = $state.href(toState.name, toParams).substr(1);

      $rootScope.bodyClass = toParams.bodyClass || (toState.data && toState.data.bodyClass) || 'bg';
      $rootScope.pageTitle = toParams.pageTitle || (toState.data && toState.data.pageTitle) || 'Lightning Book';

      if (APP_CONFIG.analytics.enabled) {
        Analytics.set('page', pagePath);
        Analytics.trackPage(pagePath, $rootScope.pageTitle);
      }

      if (APP_CONFIG.appInsights.enabled) {
        appInsightsService.trackPageView(pagePath);
      }

      if (authService.isAuthenticated()) {
        if (!Idle.running()) {
          Idle.watch();
        }
      } else {
        Idle.unwatch();
      }
    }),
]);

app.run([
  '$rootScope',
  '$state',
  'AUTH_EVENTS',
  ($rootScope, $state, AUTH_EVENTS) =>
    $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
      if (
        app.previousSate &&
        !(app.previousSate.toParams.isPublic || (app.previousSate.toState.data && app.previousSate.toState.data.isPublic))
      ) {
        $state.go(app.previousSate.toState, app.previousSate.toParams);
      } else {
        $state.go('app.home');
      }
      // $rootScope.$broadcast('loadBeamer');
    }),
]);

app.run([
  '$rootScope',
  '$state',
  'AUTH_EVENTS',
  ($rootScope, $state, AUTH_EVENTS) => {
    $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
      $state.go('landing.login');
    });
  },
]);

app.run([
  '$rootScope',
  '$state',
  ($rootScope, $state) => {
    $rootScope.$on('$stateChangeError', () => {
      $rootScope.showLoader = false;
      if ($state.is('authenticate')) {
        $state.go('landing.login');
      } else {
        $state.go('app.home');
      }
    });
  },
]);

app.run([
  '$rootScope',
  'beamerService',
  ($rootScope, beamerService) => {
    $rootScope.$on('loadBeamer', function () {
      if (!window.beamer_config) return;

      const auth = JSON.parse(localStorage.getItem('oauth'));
      if (!auth || !auth.access_token) return;

      beamerService.get().then((response) => {
        beamerService.setCount(response.count);
        beamerService.setUrl(response.url);
        if (response.url) $('#beamerFrame').attr('src', response.url);
      });
    });

    $rootScope.$broadcast('loadBeamer');
  },
]);

export default app;



// WEBPACK FOOTER //
// ./src/app.js